import {
  AngleIcon,
  BlendingModeIcon,
  ColorWheelIcon,
  Component1Icon,
  Component2Icon,
  ComponentBooleanIcon,
  ComponentPlaceholderIcon,
  MarginIcon,
  MixIcon,
  OverlineIcon,
  PaddingIcon,
  ShadowIcon,
  ShadowOuterIcon,
  ShadowInnerIcon,
  StackIcon,
} from "@radix-ui/react-icons";

export const Logo = (props: React.ComponentProps<typeof MixIcon>) => {
  return (
    <>
      <OverlineIcon {...props} />
    </>
  );
};
